module.exports = __webpack_public_path__ + "static/media/right_arrow.afe2e04a.svg";